module.exports = __webpack_public_path__ + "img/robot_2.959df201.png";